import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { CollectionService } from '@services/collection.service';
import { RoleManagementService } from '@services/role.management.service';
import { UserService } from '@services/user.service';
import { Subscription } from 'rxjs';
import { RoleManagement } from '@configs/role.config';
import { WebErrorService } from '@services/webError.service';
import { IdleService } from 'src/app/shared/idle.service';
import { ExamineeloginService } from '@services/examineelogin.service';
import { DeliveryService } from '@services/delivery.service';
import { NotificationService } from '@services/notification.service';
@Component({
  selector: 'app-change-password',
  templateUrl: './change-passwordD.component.html',
  styleUrls: ['./change-passwordD.component.scss']
})
export class ChangePasswordDComponent implements OnInit {
  fullyear = new Date().getFullYear();
  changePassword: FormGroup;
  submitted: any;
  captchaData$: Subscription;
  CaptchaImgUrl: string = "";
  CaptchaTextValue: string = "";
  CaptchaTokenValue: string = "";
  isValid: boolean = false;
  isDisplayError: boolean = false;
  loginErrorMessage: any;
  userData: any;
  collectionData$: Subscription | undefined;
  examineeServiceSubscription$: Subscription;
  testDetails: any;
  testbankuuId: any;
  validateCaptcha$: Subscription;
  constructor(public fb: FormBuilder,
    private examineeloginservice: ExamineeloginService,
    private router: Router,
    private roleSer: RoleManagementService,
    private collectionService: CollectionService,
    private webErrorService: WebErrorService,
    public idleService: IdleService,
    private notificationService: NotificationService,
    private deliveryService: DeliveryService,) {
      this.CaptchaImgUrl = '../../../assets/favicon/images.jfif';
      this.userData = JSON.parse(localStorage.getItem('userData'));
    }

  ngOnInit(): void {
    this.CaptchaImgUrl = '../../../assets/favicon/images.jfif';
    this.changePassword = this.fb.group({
      oldPassword: new FormControl('',
        [Validators.required]),
      newPassword: new FormControl('',
        [Validators.required,
        Validators.minLength(12),
        Validators.maxLength(20),
        Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%&*^])[a-zA-Z0-9!@#$%&*^]{12,}$')]),
      confirmPassword: new FormControl('',
        [Validators.required,
        Validators.minLength(12),
        Validators.maxLength(20),
        Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%&*^])[a-zA-Z0-9!@#$%&*^]{12,}$'),]),
      captchaText: new FormControl('', [Validators.required])
    });

    this.getCaptcha();
  }

  get f() {
    return this.changePassword.controls;
  }

  getCaptcha(){
    if(this.captchaData$){this.captchaData$.unsubscribe();}
    this.captchaData$ = this.examineeloginservice.getCaptcha().subscribe(data => {
      if(data) {
        this.CaptchaImgUrl = data.dntCaptchaImgUrl;
        this.CaptchaTokenValue = data.dntCaptchaTokenValue;
        this.CaptchaTextValue = data.dntCaptchaTextValue;
      }
    });
  }

  resendCaptcha() {
    this.getCaptcha();
  }

  submit() {
    let payloadForChange = {
      "id": this.userData.useruuid,
      "emailId": this.userData.email,
      "oldPassword": this.changePassword.value.oldPassword,
      "newPassword": this.changePassword.value.newPassword,
      "confirmPassword": this.changePassword.value.confirmPassword
    }
    if(this.validateCaptcha$){this.validateCaptcha$.unsubscribe();}
    this.validateCaptcha$= this.examineeloginservice.validateCaptcha(this.CaptchaTokenValue, this.CaptchaTextValue, this.changePassword.value.captchaText)
    .subscribe((res)=>{
      if(res && res.status === 'true') {
        this.examineeloginservice.changePassword(payloadForChange).subscribe((res) => {
          if (res.success) {
            this.loginErrorMessage = ''
            this.notificationService.success(res.message);
            let payload = {
              "emailId": this.userData.email,
              "password": this.changePassword.value.confirmPassword,
              "testscheduleuuid": this.userData.schId
            }

            this.examineeServiceSubscription$ = this.examineeloginservice.signIn(payload).subscribe((data) => {
              if (data.status != false) {
                this.deliveryService.getExamineeTest(this.userData.schId).subscribe(resData => {
                  this.testDetails = resData;
                  this.testbankuuId = this.testDetails?.testbankuuId;
                  this.router.navigate(['/delivery/start/test', this.testbankuuId]);
                }, (error: any) => {
                  this.webErrorService.handleAPIErrors(error, null, true, 'warn');
                });
              } else {
                this.isValid = false;
                this.isDisplayError = false;
                this.loginErrorMessage = data.message;
                this.resendCaptcha();
              }
            }, (error: any) => {
              this.isValid = false;
              this.isDisplayError = false;
              this.loginErrorMessage = error.error.message;
              this.resendCaptcha();
            });
          }
        },
        error => { this.loginErrorMessage = error.error.message;this.resendCaptcha(); });
      } else {
        this.resendCaptcha();
        this.isDisplayError = false;
        this.loginErrorMessage = res.message
      }
    });

  }

  resetIdealLogoutFlag(): void {
    this.idleService.showIdealLogoutMessage = false;
    localStorage.removeItem('Idle_logout');
  }

  cancel() {
    this.router.navigate(['/login']);
  }
}
